module.exports = __webpack_public_path__ + "img/pro-photo9.1c2874bb.png";